<ng-template #skeleton>
  <div [ngClass]="{'scroll-item-width': !fullWidth, 'w-100': fullWidth}"
       class="app-card-box card-box__custom-dm">
    <div class="d-flex gap-2">
      <div class="w-100 d-flex ion-justify-content-between">
        <ngx-skeleton-loader [theme]="{height: '8px'}" class="w-10"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{height: '8px'}" class="w-10"></ngx-skeleton-loader>
      </div>
    </div>
    <div class="d-flex flex-column">
      <ngx-skeleton-loader [theme]="{height: '8px'}" class="w-80"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '8px'}" class="w-10"></ngx-skeleton-loader>
    </div>
    <div class="d-flex flex-column">
      <ngx-skeleton-loader [theme]="{height: '8px'}" class="w-100"></ngx-skeleton-loader>
      <ngx-skeleton-loader [theme]="{height: '8px'}" class="w-100"></ngx-skeleton-loader>
    </div>
  </div>
</ng-template>
<div class="app-card-box app-card-box__custom-height"
     *ngIf="!showSkeleton && job; else skeleton"
     [ngClass]="{'scroll-item-width': !fullWidth, 'w-100': fullWidth}"
     (click)="onOpenDetail()">

  <div class="d-flex gap-4 ion-justify-content-between w-100 h-100"
       *ngIf="vediTutte; else cardContent">
    <div class="ts-caption-bold">Vedi tutti <br>gli annunci</div>
    <div>
      <ion-icon style="font-size: 30px" name="arrow-forward-circle-outline"></ion-icon>
    </div>
  </div>

  <ng-template #cardContent>
    <div class="d-flex flex-column ion-justify-content-between h-100">
      <div>
        <div class="d-flex ion-justify-content-between mb-sm">
          <div class="ts-small pt-xs">{{ job.createdAt | dayAgo }}</div>
          <div class="ts-small pt-xs">{{ job.getAddressPreview() }}</div>
        </div>
        <div class="ts-body-bold text-ellipsis two-line">{{ job.name }}</div>
      </div>
      <div class="ts-caption pt-xs text-neutral-600">{{ job.companyName }}</div>
    </div>
  </ng-template>

</div>


<ion-modal [isOpen]="isOpenModal"
           #drawerModal
           (didDismiss)="isOpenModal = false"
           [initialBreakpoint]="1"
           [breakpoints]="[0, 1]">
  <ng-template>

    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="onClose()" fill="clear" size="small">
            <span class="material-symbols-outlined">close</span>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">

      <ng-template #detailSkeleton>
        <ngx-skeleton-loader [theme]="{height: '90px'}" class="w-100"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{height: '8px'}" class="w-100"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{height: '8px'}" class="w-100"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="{height: '8px'}" class="w-100"></ngx-skeleton-loader>
      </ng-template>

      <div class="content-box__success"
           *ngIf="!isLoadingDetail; else detailSkeleton">
        <div class="w-100 mt-sm">

          <div class="pb-md">
            <div class="ts-body-bold" [innerHTML]="job.name"></div>
            <div class="ts-small-bold text-neutral-400">{{job.createdAt | appDate: 'DD MMM YYYY'}}</div>
          </div>

          <app-accordion-list [single]="true">

            <app-accordion-item [expanded]="true">

              <div header>Info</div>

              <ion-row>

                <ion-col size="12">
                  <app-text-value
                    [value]="job.companyName"
                    [label]="'Azienda' | translate"></app-text-value>
                </ion-col>

                <ion-col size="6">
                  <app-text-value
                    [value]="job.recruiterName || 'Non_specificato' | translate"
                    [label]="'Referente' | translate"></app-text-value>
                </ion-col>

                <ion-col size="6">
                  <app-text-value
                    [value]="job.sourceName"
                    [label]="'Fonte' | translate"></app-text-value>
                </ion-col>

              </ion-row>

            </app-accordion-item>

            <app-accordion-item>

              <div header>Città</div>

              <div style="overflow-y: scroll;max-height: 200px;">
                <ul>
                  <li *ngFor="let city of job.getCities()">{{ city }}</li>
                </ul>
              </div>

            </app-accordion-item>

            <app-accordion-item>

              <div header>Descrizione</div>

              <div style="overflow-y: scroll;max-height: 200px;" [innerHTML]="job.description"></div>

            </app-accordion-item>

          </app-accordion-list>

        </div>

      </div>

    </ion-content>

    <ion-footer>
      <ion-toolbar>
        <div class="w-100 mt-sm d-flex ion-justify-content-between">
          <ion-button class="w-100" (click)="openLink(job?.externalUrl)">
            <div class="material-symbols-outlined pr-sm">search</div>
            {{ 'Vedi_annuncio' | translate }}
          </ion-button>
          <ion-button (click)="onShare()"
                      class="default">
            <ion-icon name="share-outline"></ion-icon>
          </ion-button>
        </div>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
